import { Link } from "@tanstack/react-router";
import { HelpMenu } from "@/components/help-menu";
import { ThemeToggle } from "@/components/theme-toggle";
import { Button } from "@/components/ui/button";
import logoPng from "@/logo.png";

export function PublicHeader() {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="flex h-16 w-full items-center justify-between px-4 lg:px-6">
				{/* Logo */}
				<Link to="/" className="flex items-center gap-2">
					<img src={logoPng} alt="m8tes.ai" className="size-20 shrink-0 dark:invert" />
				</Link>

				{/* Auth Buttons & Theme Toggle */}
				<div className="flex items-center gap-2">
					<ThemeToggle />
					<Button variant="ghost" size="sm" asChild>
						<Link to="/login">Log in</Link>
					</Button>
					<Button size="sm" asChild>
						<Link to="/signup">Get started for free</Link>
					</Button>
					<HelpMenu />
				</div>
			</div>
		</header>
	);
}
